exports.serviceTeam="brochure";
exports.serviceType="info";
exports.authServerHost = `${process.env.REACT_APP_AUTH_API_URL}`;